


































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import firebase from 'firebase';
import { mapActions, mapGetters } from 'vuex';
import {
  OtherModel,
  ProfileModel,
  SkillModel,
  StatusModel,
  BackStoryModel,
  JobPointFormula,
} from '@/model/charactersheets';
import DeleteModalContainer from '@/components/DeleteModal/container.vue';
import GlobalHeaderContainer from '@/components/Header/container.vue';
import GlobalFooterContainer from '@/components/Footer/container.vue';
import LoadingContainer from '@/components/Loading/container.vue';

@Component({
  components: {
    GlobalHeaderContainer,
    GlobalFooterContainer,
    LoadingContainer,
    DeleteModalContainer,
  },
})
export default class Read extends Vue {
  private btnToggle: boolean = false;
  private deleteModal: boolean = false;
  private skillDetail: boolean = false;
  private statusDetail: boolean = false;
  private userCheck: boolean = false;
  private viewCheck: boolean = false;
  private isReading: boolean = true;
  private isWriting: boolean = false;

  @Getter('Charactersheets/getUid') private csUid;
  @Getter('Charactersheets/getOther') private others;
  @Getter('Charactersheets/getProfile') private profiles;
  @Getter('Charactersheets/getSkill') private skills;
  @Getter('Charactersheets/getStatus') private statuses;
  @Getter('Charactersheets/getPrivate') private isPrivate;
  @Getter('Charactersheets/getGameSystem') private gamesystem;
  @Getter('Charactersheets/getBackStory') private backStory;
  @Getter('Charactersheets/getJobPointFormula') private jobPointFormula;
  @Getter('User/getUser') private user;
  @Getter('User/getStatus') private userStatus;

  @Action('Charactersheets/updateOther') private updateOther!: (payload: OtherModel) => void;
  @Action('Charactersheets/updateProfile') private updateProfile!: (payload: ProfileModel) => void;
  @Action('Charactersheets/updateSkill') private updateSkill!: (payload: SkillModel[]) => void;
  @Action('Charactersheets/updateStatus') private updateStatus!: (payload: StatusModel) => void;
  @Action('Charactersheets/updateUid') private updateUid!: (payload: string) => void;
  @Action('Charactersheets/updatePrivate') private updatePrivate!: (payload: boolean) => void;
  @Action('Charactersheets/updateGameSystem') private updateGameSystem!: (payload: number) => void;
  @Action('Charactersheets/updateBackStory') private updateBackStory!: (payload: BackStoryModel) => void;
  @Action('Charactersheets/updateJobPointFormula') private updateJobPointFormula!: (payload: JobPointFormula) => void;
  @Action('User/updateUser') private updateUser!: (payload) => void;
  @Action('User/updateStatus') private updateUserStatus!: (payload: boolean) => void;

  public get gamesystemText() {
    return this.gamesystem === 0 ? 'クトゥルフ神話TRPG（6th edition）' : '新クトゥルフ神話TRPG（7th edition）';
  }

  private get FormulaText() {
    switch (this.jobPointFormula) {
      case 0:
        return 'EDU × 4';
      case 1:
        return 'EDU×2 + DEX×2';
      case 2:
        return 'EDU×2 + STR×2';
      case 3:
        return 'EDU×2 + POW×2';
      case 4:
        return 'EDU×2 + APP×2';
      default:
        return 'EDU × 4';
        break;
    }
  }

  private get jobpoint(): number {
    const basePoint = (this.statuses.edu.default + this.statuses.edu.correction) * 10;
    switch (this.jobPointFormula) {
      case 0:
        return basePoint + (this.statuses.edu.default + this.statuses.edu.correction) * 10;
      case 1:
        return basePoint + (this.statuses.dex.default + this.statuses.dex.correction) * 10;
      case 2:
        return basePoint + (this.statuses.str.default + this.statuses.str.correction) * 10;
      case 3:
        return basePoint + (this.statuses.pow.default + this.statuses.pow.correction) * 10;
      case 4:
        return basePoint + (this.statuses.app.default + this.statuses.app.correction) * 10;
      default:
        return basePoint + (this.statuses.edu.default + this.statuses.edu.correction) * 10;
        break;
    }
  }

  private get interestpoint() {
    return (this.statuses.int.default + this.statuses.int.correction) * 10;
  }
  private get jobusepoint() {
    let jobTotal = 0;
    this.skills.forEach(element => {
      jobTotal += element.jobpoint;
    });
    return jobTotal;
  }
  private get interestusepoint() {
    let interestTotal = 0;
    this.skills.forEach(element => {
      interestTotal += element.interestpoint;
    });
    return interestTotal;
  }
  private get currentUser() {
    return firebase.auth().currentUser;
  }
  private get postid() {
    return this.$route.params.id;
  }

  public statusFormatter(payload: number) {
    return this.gamesystem === 0 ? payload : payload * 5;
  }

  public textareaFormatter(payload: string) {
    return payload ? payload.replace(/\n/g, '<br/>') : '';
  }

  private dataget() {
    return new Promise((resolve, reject) => {
      firebase
        .firestore()
        .collection('Character')
        .doc(this.postid)
        .get()
        .then(querySnapshot => {
          if (querySnapshot) {
            const data = querySnapshot.data();
            const skill = data!.skill ? data!.skill : [];
            const gamesystem = data!.gamesystem ? data!.gamesystem : 0;
            const formula = data!.jobPointFormula ? data!.jobPointFormula : 0;
            this.updateProfile(data!.profile);
            this.updateStatus(data!.status);
            this.updateOther(data!.other);
            this.updateUid(data!.userid);
            this.updatePrivate(data!.isPrivate);
            this.updateBackStory(data!.backStory);
            this.updateGameSystem(gamesystem);
            this.updateSkill(skill);
            this.updateJobPointFormula(formula);
            resolve();
          }
        });
    });
  }

  private check() {
    return new Promise((resolve, reject) => {
      if (this.currentUser && this.isPrivate) {
        if (this.currentUser!.uid === this.csUid) {
          this.viewCheck = true;
          this.userCheck = true;
        }
      } else if (this.currentUser && !this.isPrivate) {
        this.viewCheck = true;
        if (this.currentUser!.uid === this.csUid) {
          this.userCheck = true;
        }
      } else if (!this.currentUser && this.isPrivate) {
        this.viewCheck = false;
        this.userCheck = false;
      } else {
        this.viewCheck = true;
        this.userCheck = false;
      }
      this.isReading = false;
      resolve();
    });
  }

  private async init() {
    await this.dataget();
    await this.check();
  }

  public skillDefaultShow() {
    this.skillDetail = false;
  }
  public skillDetailShow() {
    this.skillDetail = true;
  }
  public statusDefaultShow() {
    this.statusDetail = false;
  }
  public statusDetailShow() {
    this.statusDetail = true;
  }
  public openDeleteModal() {
    this.deleteModal = true;
  }
  public closeDeleteModal() {
    this.deleteModal = false;
  }
  public csRemove() {
    this.isWriting = true;
    firebase
      .firestore()
      .collection('Character')
      .doc(this.postid)
      .delete()
      .then(() => {
        this.$router.push(`/`);
      })
      .catch(() => {
        this.isWriting = false;
      });
  }
  public toEdit() {
    this.isWriting = true;
    this.$router.push(`/character/${this.postid}/edit`);
  }

  public created() {
    this.init();
  }
}
